<template>
  <!-- 批量绑定女优 -->
  <el-dialog title="批量绑定女优" :visible="visible" @update:visible="updateVisible" width="600px" @close="closeEditActress">
    <el-form ref="form" label-width="100px">
      <el-form-item label="女优ID">
        <el-input style="width: 450px;" type="textarea" rows="5" v-model="actressIds" placeholder="请输入女优ID，多个女优ID请用空格隔开"
          size="small"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeEditActress">取 消</el-button>
      <el-button type="primary" @click="batchSetActressId" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogBindActresses',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actressIds: ''
    }
  },
  methods: {
    closeEditActress() {
      this.updateVisible(false)
    },
    updateVisible(visible) {
      this.$emit('update:visible', visible)
    },
    batchSetActressId() {
      if (!this.actressIds) {
        this.$message.error('请输入女优ID')
        return
      }
      this.$emit('submit', this.actressIds)
    }
  }
}
</script>

<style lang="scss" scoped></style>